import React from 'react';
import PropTypes from 'prop-types';

import {Box, Tabs, Tab} from '@mui/material';

import { LineLoader, Inspector } from '@timmons-group/shared-react-components';

import { styled } from '@mui/material/styles';
import debounce from 'lodash/debounce';
import FilterableTabPanel from 'HVRA/components/FilterableTabPanel';


function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TabPanel = ({ children, value, index, ...props }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...props}
    >
      {value === index && <Box sx={{ padding: '12px' }}>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};


const ValuesExplorerTabPanel = ({categories, mapReady, featData, selectedTab, forceUpdate, onClearButtonClick, onTabChanged, onFiltersUpdated, onExcludeSwitchChange, onAnalyzeThisArea}) => {
  React.useEffect(() => {
    if (categories?.length > 0) {
      onFiltersUpdated(categories);
    }
  }, [categories]);

  // before calling the parent function, we can inject any special logic needed here.
  const filterMap = (item) => {
    onFiltersUpdated(item);
  }

  const debounceFilterMap = debounce(filterMap, 1200, {
    leading: false,
    trailing: true
  });

  const handleFilterChange = (item) => {
    debounceFilterMap(item);
  }

  const CustomTabs = styled(Tabs)(({ theme }) => ({
    color: theme.palette.tertiary.lightBlue,
    '& .MuiTab-root': {
      backgroundColor: theme.palette.tertiary.lightBlue,
      width: '50%',
      color: 'white',
      '&:focus, &:hover': {
        backgroundColor: theme.palette.hover.dark,
      },
      '&.Mui-selected': {
        color: 'white',
        backgroundColor: theme.palette.primary.main,
      },
    },
  }));

  const renderInspector = () => {
    if (mapReady) {
      if (featData?.cardData) {
        return (
          <Inspector
            cardData={featData.cardData}
            featuredCard={featData.featuredCard}
            heading="Selected Area"
            theme={featData.theme}
            onHeaderActionClicked={onClearButtonClick}          />
        );
      }
      return null;
    }

    return <LineLoader />;
  };


  return (
    <>
      <Box>
        <CustomTabs
          value={selectedTab}
          onChange={onTabChanged}
          aria-label="values explorer tabs"
        >
          <Tab label="Inspector" {...a11yProps(0)} />
          <Tab label="Values Explorer" {...a11yProps(1)} />
        </CustomTabs>
      </Box>
      <TabPanel value={selectedTab} index={0}>
        {renderInspector()}
      </TabPanel>
      <TabPanel value={selectedTab} index={1} sx={{ padding: 5 }}>
        <FilterableTabPanel
          filterGroups={categories}
          onFilterChange={handleFilterChange}
          onSwitchChange={onExcludeSwitchChange}
        ></FilterableTabPanel>
      </TabPanel>
    </>
  );
};

ValuesExplorerTabPanel.propTypes = {
  categories: PropTypes.array,
  mapReady: PropTypes.bool,
  featData: PropTypes.object,
  selectedTab: PropTypes.number,
  forceUpdate: PropTypes.number,
  onClearButtonClick: PropTypes.func.isRequired,
  onTabChanged: PropTypes.func,
  onFiltersUpdated: PropTypes.func.isRequired,
  onExcludeSwitchChange: PropTypes.func.isRequired
};

export default ValuesExplorerTabPanel;
